export enum PrintModelType {
  Standard = "StandardModel",
  DPA = "DPAModel",
  Luxcreo = "LuxcreoModel"
}

export enum LabelStagingType {
  Yes = "StageYes",
  No = "StageNo"
}

export enum SelectToothType {
  SecondPremolarLeft = "Second_Premolar-left",
  FirstMolarLeft = "First_Molar-left",
  SecondPremolarRight = "Second_Premolar-right",
  FirstMolarRight = "First_Molar-right"
}

export enum SelectSideType {
  Buccal = "Buccal",
  Lingual = "Lingual"
}

export enum UnderCutType {
  Yes = 0,
  No = 1
}

export enum YesNoType {
  Yes = 1,
  No = 0
}

export enum PrintDirectionType {
  Horizontal = 0,
  Vertical = 1
}

export enum ContourMachineType {
  new = 0,
  NoTrim = 1,                 // No Trim Machine (No output trim line data output)
  DigitalDental = 2,         // Digital Dental Trimming Machine
  GeneralTrimming = 3,        // General Trimming Machine (No mounting fixture at bottom of model)
}

export enum IncludeLabelType {
  Yes = "YesCaseNumber",
  No = "NoCaseNumber"
}

export enum SelectPositionType {
  Bottom = "Bottom",
  LingualWall = "WallLingual",
  BuccalWall = "Wall"
}

export enum CaseTagType {
  FirstNameInitial = 1,
  FirstName = 2,
  LastNameInitial = 3,
  LastNameShort = 4,    // up to 7 char
  LastName = 5,
  StageNumber = 6,
  Empty = 7
}

export interface ILuxcreoModel {
  LabelStagingNumber: LabelStagingType
  SelectToothNumber: SelectToothType
  SelectSideNumber: SelectSideType
  IncludeLabelModel: IncludeLabelType
  SelectPositionLabel: SelectPositionType
  UnderCut: UnderCutType
  UseuContourMachine: ContourMachineType
  GenerateShell: YesNoType
  DrainHole: Number
  ShellThickness: number
  PrintDirection: PrintDirectionType
  HeightOfWall: number
  DPAOffset: number
  DPAthickness: number
  CaseTag: CaseTagType[]
}
export interface IDPAModel {
  LabelStagingNumber: LabelStagingType
  SelectToothNumber: SelectToothType
  SelectSideNumber: SelectSideType
  IncludeLabelModel: IncludeLabelType
  SelectPositionLabel: SelectPositionType
  UnderCut: UnderCutType
  UseuContourMachine: ContourMachineType
  GenerateShell: YesNoType
  DrainHole: YesNoType
  ShellThickness: number
  PrintDirection: PrintDirectionType
  HeightOfWall: number
  DPAOffset: number
  DPAthickness: number
  CaseTag: CaseTagType[]
}
import { IShippingAddressTo } from "../../../model/interface/IShippingAddress"
export interface IDefinAttachmentTemplate {
  id: number
  name: string
  data: string // JSON string
  addOption: boolean
  isEnable: boolean
  modify: boolean
}
export interface IDefineAttachment {
  AttPlace:any
  BCustom:number
  CalculateMatrix:number
  DefaultPos:number
  Version:number
}


export interface IPrintSettingJsonObj{
  CaseTag?: number[],
  DPAOffset?: number,
  DPAthickness?: number,
  DrainHole?: number,
  GenerateShell?: number,
  HeightOfWall?: number,
  IncludeLabelModel?:string,
  LabelStagingNumber?: string,
  PrintDirection?: number,
  SelectPositionLabel?: string,
  SelectSideNumber?: string,
  SelectToothNumber?: string,
  ShellThickness?: number,
  UnderCut?: number,
  UseuContourMachine?: number,
}

export enum EPrintModel {
  StandardModel = "StandardModel",
  DPAModel = "DPAModel",
  LuxcreoModel = "LuxcreoModel",
}

export interface IPrintingSettings{
  DefaultModel?:EPrintModel,
  StandardModel?:IPrintSettingJsonObj,
  DpaModel?:IPrintSettingJsonObj,
  LuxcreoModel?:IPrintSettingJsonObj,
}

export interface IClinicalSettings {
  CuttingLineCP: number
  NumberSystem: string
  CuttingLineCC: number
  CuttingLineOffset: number
  AttachmentStage: number
  stage_number?: string
  toothLabel?: string[]
  LabelStagingNumber?: string
  LabelStagingNumberStart?: string
  StageNumberLeftOrRight?: boolean
  UnderCut?: number
  UseuContourMachine?: number
  LabelLocation?: string
  CaseTag?: number[]
  DefinAttachmentTemplate?: IDefinAttachmentTemplate[]
  DefineAttachment?: IDefineAttachment
  GenerateShell?: number
  DrainHole?: number
  ShellThickness?: number
  PrintDirection?: number
  HeightOfWall?: number
  DefaultStep_angle?: number
  DefaultStep_length?: number
  PrintSetting?: IPrintingSettings
  PrintDefaultModel?: PrintModelType
  StandardModel?: IStandardModel
  DPAModel?: IDPAModel
  LuxcreoModel?: ILuxcreoModel
  RunQualityCheckAfterPreSetup?: boolean
}
export interface IUserProfile {
  firstName: string
  lastName: string
  username?: string
  user_type?: string
  org_name?: string
  profileIconClrCode?: string
  createDate?: string
  updateDate?: string
}

export interface IUserPreferences {
  on_show_both_scan_upload_warning?: boolean
  onboarding_no_shows?: boolean
  profileIconColor?: string
  last_assigned_to?: string
  on_show_new_patient_cancel_warning?: boolean
  on_show_sort_warning?: boolean
  on_show_setting_tooltip?: boolean
  on_show_welcome_modal?: boolean
  do_not_show_modelcheck_popover?: boolean
}

export interface ISuggestedAddressData {
  city: string
  entries: number
  secondary: number
  state: string
  street_line: string
  zipcode: string
  street_address?: string
}

type Loading = "idle" | "pending" | "succeeded" | "failed"
export interface IUserServiceState {
  user: {
    authorized_roles: []
    global_permissions: []
    app_permissions: []
    email: string
    name: string
    my_orgId: string
    current_orgId: string
    user_id: string
    uid: string
    preferences?: IUserPreferences
    isAllowToViewAllOrg: boolean
  }
  suggestedAddressData: ISuggestedAddressData[]
  userProfile?: IUserProfile
  clinicalSettings?: IClinicalSettings
  loading?: Loading
  clinicalSettingStatus?: "idle" | "pending" | "succeeded" | "failed"
  saveOrUpdatecreditCardStatus?: "idle" | "pending" | "succeeded" | "failed"
  states: string[]
  countries: { label: string; id: number }[]
  paymentInfo: IGetCardPayload
  showTokenExpired: "reset" | "activation" | ""
  successMessage: string
  errorMessage: string
  countryCode: string
  clinicalSettingsFetchStatus: boolean
  companyProfile: ICompanyProfile
  systemBannerMessage: { [key: string]: string }
  marketBannerMessage: { [key: string]: string }
  orgShippingAddressList: IShippingAddressTo[]
  workflow: {
    showWorkflow: boolean
    phase: {
      id: number
      value: string
      color: string
    }[]
  },
  caseDispositionList: {
    id: number
    key: string
    isDisableDropdownShow: boolean
    type?: string
    displayText: string
    style: {
      color?: string
      backgroundColor?: string
      variant?: string
    }
  }[],
  attachInit: boolean
}

export interface IUpdateUser {
  first_name: string
  last_name: string
}
export interface IUpdatePassword {
  old_password: string
  new_password: string
}

export interface ICreditCard {
  card_number: string
  expiration_date: string
  card_code: string
}

export interface IBillPayload {
  name: string
  address_line: string
  address_line_1: string
  city: string
  state: string
  country: string
  zip_code: string
}
export interface IUpdateCardPayload {
  payment_profile: {
    bill_to: IBillPayload
    payment: {
      credit_card: ICreditCard
    }
  }
}
export interface IGetCardPayload {
  org_id: string
  customer_profile_id: string
  customer_payment_profile_id: string
  status: string
  card_details: {
    card_number: string
    expiry_month: string
    expiry_year: string
    holder_name: string
  }
  billing_address: IBillPayload
}

export interface IResetPassword {
  username: string
  password: string
  answer: string
  state_token: string
  okta_user_id: string
}

export interface IForgotPassword {
  username: string
}

export interface AccountActivateParams {
  tou_accepted_flag: string
  lang_code: string
  country_code: string
  user_password: string
  okta_user_id: string
  username: string
  security_question: { question: string; answer: string }
}

export interface ICompanyProfile {
  id: number
  name: string
  orgType: string
  orgStatus: string
  orgCreatedOn: string
  activatedOn: string
  invoiceStartDate: string
  licenseValidDate: string
  billingMethod: string
  address: IAddress[]
  accountOwner: string
  clinicalEdSpec: string
}

export interface IAddress {
  line_1: string
  line_2: string
  state: string
  regionName: string
  countryName: string
  city: string
  zipCode: string
  email: string
  phone: string
  type: string
}

export interface IStandardModel {
  LabelStagingNumber: LabelStagingType         // e.g. LabelStagingType.Yes
  SelectToothNumber: SelectToothType          // e.g. SelectToothType.SecondPremolarLeft
  SelectSideNumber: SelectSideType           // e.g. SelectSideType.Buccal
  IncludeLabelModel: IncludeLabelType       // e.g. IncludeLabelType.Yes
  SelectPositionLabel: SelectPositionType    // e.g. SelectPositionType.Bottom
  UnderCut: UnderCutType            // e.g. UnderCutType.No
  UseuContourMachine: ContourMachineType    // e.g. ContourMachineType.DigitalDental
  GenerateShell: YesNoType              // e.g. YesNoType.Yes
  DrainHole: YesNoType                  // e.g. YesNoType.No
  ShellThickness: number             // e.g. 2.5
  PrintDirection: PrintDirectionType  // e.g. PrintDirectionType.Vertical
  HeightOfWall: number               // e.g. 3
  DPAOffset: number                  // e.g. 0
  DPAthickness: number               // e.g. 0.5
  CaseTag: CaseTagType[]            // e.g. [CaseTagType.FirstNameInitial, CaseTagType.LastNameShort, CaseTagType.StageNumber, CaseTagType.Empty]
}
